const GraphPrefix = require('./GraphPrefix');

class AccessGroupsPrefix extends GraphPrefix {
	constructor({ graphUrl, graphServer }) {
		super({ name: 'access_groups', graphUrl, graphServer })
	}
}

module.exports = AccessGroupsPrefix;